import { Link } from 'react-router-dom';

// A consistent "back" affordance for the dedicated screens. It uses an explicit
// target rather than history(-1): a screen can be entered directly — a deep link,
// a bookmark, a hard refresh — with no in-app history to pop, so an explicit `to`
// always lands somewhere sensible. `label` names the destination for assistive
// tech (the chevron is decorative).
//
// Pass `onClick` INSTEAD of `to` when leaving needs to be intercepted (e.g. an
// unsaved-changes prompt): it then renders as a <button> with the same look, so
// screens don't re-implement the chevron/label markup.
export default function BackLink({ to, onClick, label = 'Back' }) {
  const inner = (
    <>
      <span className="back-link__chevron" aria-hidden="true">
        ‹
      </span>
      {label}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className="back-link" onClick={onClick}>
        {inner}
      </button>
    );
  }

  return (
    <Link to={to} className="back-link">
      {inner}
    </Link>
  );
}
